import { DataGridLightClasses } from '../../models';
import React, { memo, PropsWithChildren, useMemo } from 'react';
import { AnyObjectSchema } from 'yup';

interface Value {
  classes: Partial<DataGridLightClasses>;
  schema?: AnyObjectSchema;
}
export const DataGridLightSettingContext = React.createContext<Value | null>(null);

interface Props {
  classes?: Partial<DataGridLightClasses>;
  schema?: AnyObjectSchema;
}
export const DataGridLightSettingsProvider = memo<PropsWithChildren<Props>>(
  ({ children, classes, schema }) => {
    const value = useMemo(() => {
      return {
        classes: { ...classes },
        schema,
      };
    }, [classes, schema]);
    return (
      <DataGridLightSettingContext.Provider value={value}>
        {children}
      </DataGridLightSettingContext.Provider>
    );
  },
);
